import { inferenceHttp } from '@/lib/api/inference-client';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { AudienceService } from '@inference.engine/api-client/web';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type ApiParams = Parameters<typeof AudienceService.updateAudiencePersona>[0];
type PathParam = NonNullable<ApiParams>['path'];
type BodyParam = NonNullable<ApiParams>['body'];

interface Params {
  id: PathParam['id'];
  payload: BodyParam;
}

export function useUpdatePersona() {
  const workspaceId = useCurrentWorkspaceId();
  const queryClient = useQueryClient();

  return useMutation({
    // Routed through the inference API (not persona-api directly) so the server
    // refreshes GWI stats when the persona's `gwiId` changes.
    mutationFn: (params: Params) => {
      if (!workspaceId) throw new Error('No workspaceId found');

      return AudienceService.updateAudiencePersona({
        client: inferenceHttp,
        throwOnError: true,
        headers: {
          'x-selected-workspace-id': workspaceId,
        },
        path: {
          id: params.id,
        },
        body: params.payload,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['personas', workspaceId] });
    },
  });
}
